import * as React from "react";
import classNames from "classnames";
import { WithStyles, Theme, createStyles, withStyles } from "@material-ui/core";

import Toolbar, { ToolbarProps } from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";

export interface TiteledPaperProps {
	title: string;
	toolbarProps?: Partial<ToolbarProps>;
	toolbarClassName?: string;
	toolbarContent?: React.ReactNode;
}

type Props = TiteledPaperProps & WithStyles<typeof styles>;

export class TiteledPaper extends React.Component<Props, {}> {
	render() {
		const {
			classes,
			children,
			title,
			toolbarProps,
			toolbarClassName,
			toolbarContent
		} = this.props;

		return (
			<Paper>
				<Toolbar
					{...toolbarProps}
					className={classNames(classes.toolbar, toolbarClassName)}
					variant="dense"
				>
					<Typography
						className={classes.toolbarTitle}
						variant="subheading"
						component="h4"
					>
						{title}
					</Typography>
					{toolbarContent}
				</Toolbar>
				<div className={classes.content}>{children}</div>
			</Paper>
		);
	}
}

const styles = (theme: Theme) =>
	createStyles({
		toolbar: {
			background: theme.palette.primary.main,
			color: "white",
			borderRadius: "4px 4px 0 0",
			paddingLeft: theme.spacing.unit * 2,
			paddingRight: theme.spacing.unit * 2,
			display: "flex",
			flexDirection: "row",
			justifyContent: "space-between",

			"& > *": {
				color: "white",
				fontWeight: 500
			}
		},
		toolbarTitle: {
			color: "black",
			fontWeight: 500
		},
		content: {
			padding: theme.spacing.unit * 2
		}
	});

export const ConnectedTiteledPaper = withStyles(styles)(TiteledPaper);
